import { Parsing } from "./parsing";

class SkEvent extends Parsing {
  private cs: any;

  constructor(
    private elem: HTMLElement,
    private prop: string,
    private value: string,
    private module: any
  ) {
    super();
    const arr = value.match(/([^\s(]+)[\s(]+([\w\W]+)?\)$/);
    this.getParams(arr);
    this.bindEvent(arr[1]);
  }

  getParams(arr) {
    const _this = this;
    this.elem[arr[1]] = function (...args) {
      _this.cs = args;
    };
    new Function("const $data = this.module; return this.elem." + arr[0]).call(
      this
    );
  }

  bindEvent(evs): void {
    const _this = this;
    this.elem[`on${this.prop}`] = function (ev) {
      console.log(evs, _this.module);
      _this.module[evs](ev, ..._this.cs);
    };
  }
}

export { SkEvent };
